import { useStore } from "@/store";
import { observer } from "mobx-react";
import React from "react";
import { OrderShippingEmergentDetailsPanel } from "./OrderShippingEmergentDetails";
import { OrderShippingDetailsBasePanel } from "./OrderShippingDetailsBase";

export const OrderShippingDetailsPanel = observer(() => {
  const { isEmergentFlow } = useStore();

  if (isEmergentFlow) return <OrderShippingEmergentDetailsPanel />;
  else return <OrderShippingDetailsBasePanel />;
});
